import { useEffect, useState } from "react";
import getConfig from "next/config";
import classNames from "classnames";
import { connect } from "react-redux";

import UserWithLocker from "@components/ProductPage/ProductLockerAvailability/UserWithLocker";
import UserWithoutLocker from "@components/ProductPage/ProductLockerAvailability/UserWithoutLocker";
import Loading from "@components/Loading";
import { makeApiCall } from "@lib/api/helpers";
import { getLockerbyIdApi } from "@lib/api";
import ModalErrorBoundary from "@containers/ModalErrorBoundary";
import LockersMapWithFiltersModal from "@components/LockersMapWithFilters/LockersMapWithFiltersModal";
import {
  PRODUCT_PAGE_LOCKERS_MAP_ID,
  PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID,
} from "@components/Lockers/_lib/constants";
import { localClientStore } from "@lib/clientStore";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const ProductLockerAvailability = ({ user, openedModal, lockers }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLocker, setSelectedLocker] = useState(null);

  const { customer, favouriteLockerId } = user;

  const selectedLockerId =
    customer?.locker_id ||
    favouriteLockerId ||
    localClientStore.get("favourite_locker_id");

  useEffect(() => {
    const getLockerById = async () => {
      if (!isLoading) {
        setIsLoading(true);
      }

      const lockerFromList =
        lockers.length > 0 &&
        lockers.find((locker) => locker.id === selectedLockerId);

      if (lockerFromList) {
        setSelectedLocker(lockerFromList);
        setIsLoading(false);
      } else {
        const response = await makeApiCall({
          apiArgs: [selectedLockerId],
          apiCall: getLockerbyIdApi,
          formatResponse: (response) => response.data.data.locker,
        });

        if (response) {
          setSelectedLocker(response);
        }
      }

      setIsLoading(false);
    };

    if (
      (selectedLockerId && !selectedLocker) ||
      (selectedLockerId &&
        selectedLocker &&
        selectedLocker.id !== selectedLockerId)
    ) {
      getLockerById();
    } else {
      setSelectedLocker(null);
      setIsLoading(false);
    }
  }, [selectedLockerId]);

  if (isLoading)
    return (
      <div
        className={classNames("py-[40px] px-[20px]", {
          "bg-[#FAFAFA]": !isBricoStore,
          "border rounded-[4px] border-gray-light": isBricoStore,
        })}
      >
        <Loading hasMarginBottom={false} />
      </div>
    );

  return (
    <div
      className={classNames("p-[16px] rounded-[4px]", {
        "bg-[#FAFAFA]": !isBricoStore,
        "border border-gray-light": isBricoStore,
      })}
    >
      {selectedLocker ? (
        <UserWithLocker selectedLocker={selectedLocker} />
      ) : (
        <UserWithoutLocker />
      )}

      {openedModal === PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID && (
        <ModalErrorBoundary>
          <LockersMapWithFiltersModal
            mapId={PRODUCT_PAGE_LOCKERS_MAP_ID}
            modalId={PRODUCT_PAGE_MODAL_LOCKERS_MAP_ID}
          />
        </ModalErrorBoundary>
      )}
    </div>
  );
};

export default connect((state) => ({
  user: state.user,
  openedModal: state.app.modal,
  lockers: state.stores.lockers,
}))(ProductLockerAvailability);
